module.exports = __webpack_public_path__ + "static/media/img-04.3d61cff8.jpg";